import React, { FunctionComponent, useEffect, useState } from "react";
import StarIcon from "@mui/icons-material/Star"; // Import a star icon from MUI
import "./SubscribedPages.scss";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../Redux/Store/Hooks";
import { listExamID } from "../../Redux/Slices/Exam/ListExamIDSlice";
import { addStudentExam } from "../../Redux/Slices/StudentExam/AddStudentExamSlice";
import { decode } from "../../Utils/encodeDecode";
import { ILoginResponse } from "../Login/ILogin";
import { ReactComponent as LoginLogo } from "../../Assets/Images/loginlogo.svg";
import { listReExamID } from "../../Redux/Slices/ReExam/ListReExamSlice";
import {
  Button,
  Card,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  SvgIcon,
  Typography,
} from "@mui/material";
import { listUserExamList } from "../../Redux/Slices/UserPackage/ListUserExamListSlice";
import { listUserPackageDetails } from "../../Redux/Slices/UserPackage/ListUserPackageDetailsSlice";
import AlarmIcon from "@mui/icons-material/Alarm";
import {
  clearListSubscription,
  listSubscription,
} from "../../Redux/Slices/Subscription/ListSubscriptionSlice";
import { Grid } from "@mui/material";
import StripeWrapper from "../../Components/Stripe/Stripe";
import StyleIcon from "@mui/icons-material/Style";
import Cardimage from "./Card.svg";
import Successimage from "./Success.jpg";
import ButtonField from "../../Components/Button/ButtonField";
import ReportGmailerrorredIcon from "@mui/icons-material/ReportGmailerrorred";
import AppBarnav from "../../Components/AppBar/AppBar";
import {
  clearDashboardChart,
  dashboardChart,
} from "../../Redux/Slices/DashboardChart/DashboardChart";
import { Container, Box, Divider } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
interface SubscribedPagesProps { }

const SubscribedPages: FunctionComponent<SubscribedPagesProps> = () => {
  // Create an array of instruction objects
  const navigate = useNavigate();
  // const { state: exam_id } = useLocation();
  const dispatch = useAppDispatch();
  // const { data: listUserPackageDetailsSlice } = useAppSelector(
  //   (state) => state.ListUserPackageDetailsSlice
  // );
  // const Packagedetails: any = listUserPackageDetailsSlice?.data;
  // useEffect(() => {
  //   dispatch(listUserPackageDetails({ package_id: exam_id }));
  // }, []);

  // payment option

  const [open, setOpen] = useState(false);
  const [dialogMessage, setDialogMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState(true);
  const [discardOpen, setDiscardOpen] = useState(false);

  const handlePaymentSuccess = () => {
    setDialogMessage("Payment successful!");
    setIsSuccess(true);
    setOpen(true);
  };

  const handlePaymentError = (error: any) => {
    setDialogMessage(`Payment failed: ${error.message}`);
    setIsSuccess(false);
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  // ...........

  const { data: SubscriptionSlice } = useAppSelector(
    (state) => state.ListSubscriptionSlice
  );

  const [selectedPackage, setSelectedPackage] = useState<any>(null);

  useEffect(() => {
    const saved = sessionStorage.getItem("selectedPackage");
    if (saved) {
      try {
        setSelectedPackage(JSON.parse(saved));
      } catch (e) {
        console.error("Error parsing selectedPackage", e);
      }
    }
  }, []);

  const apiData = (SubscriptionSlice as any)?.data;
  const hasNewStructure = apiData?.package_details && apiData?.price_details;

  // Check where the package details are: either in the top level of the slice data or nested in .data
  const apiPackageDetails = hasNewStructure
    ? apiData.package_details
    : (SubscriptionSlice as any)?.package_name || (SubscriptionSlice as any)?.name
      ? SubscriptionSlice
      : (SubscriptionSlice as any)?.data;

  const isUCAT =
    window.location.hostname.toLowerCase().includes("ucat") ||
    window.location.hostname.toLowerCase().includes("192") ||
    window.location.hostname.toLowerCase().includes("ucattest");

  const Subcriptiondetails = {
    package_name:
      apiPackageDetails?.package_name ||
      apiPackageDetails?.name ||
      selectedPackage?.package_name ||
      selectedPackage?.name ||
      `${isUCAT ? "UCAT" : "GATE"} AI Online Question Bank`,
    cost: apiPackageDetails?.cost ?? selectedPackage?.cost ?? 9.69,
    user_cost: apiPackageDetails?.user_cost ?? selectedPackage?.user_cost,
    billing_period:
      apiPackageDetails?.billing_period ||
      selectedPackage?.billing_period ||
      "week",
    billing_type: (
      apiPackageDetails?.billing_type ||
      selectedPackage?.billing_type ||
      "monthly"
    ).toLowerCase(),
  };

  const calculateTotal = (cost: number, billingType: string) => {
    switch (billingType) {
      case "weekly":
        return cost;
      case "fortnightly":
        return cost * 2;
      case "quarterly":
        return cost * 13;
      case "yearly":
        return cost * 52;
      case "monthly":
      default:
        return Math.round(cost * 4.33 * 100) / 100; // Round to 2 decimal places or just use Math.round as before
    }
  };

  const totalAmount = hasNewStructure
    ? apiData.price_details.amount
    : calculateTotal(Subcriptiondetails.cost, Subcriptiondetails.billing_type);

  const getBillingDescription = (cost: number, billingType: string) => {
    const amount = calculateTotal(cost, billingType);
    switch (billingType) {
      case "weekly":
        return `Billed weekly ($${cost} per week).`;
      case "fortnightly":
        return `Billed fortnightly ($${cost} per week, equates to $${totalAmount} every 2 weeks).`;
      case "quarterly":
        return `Billed quarterly ($${cost} per week, equates to $${totalAmount} every 3 months).`;
      case "yearly":
        return `Billed yearly ($${cost} per week, equates to $${totalAmount} per year).`;
      case "monthly":
      default:
        return `Billed monthly ($${cost} per week, roughly 4.33 weeks in a month which equates to ~$${totalAmount}/month.)`;
    }
  };



  const [isStripeProcessing, setIsStripeProcessing] = useState(false);
  console.log(isStripeProcessing, "isStripeProcessing");


  useEffect(() => {
    window.history.pushState(null, "", window.location.href);

    const handleBackButton = (event: PopStateEvent) => {
      setDiscardOpen(true);

      window.history.pushState(null, "", window.location.href);
    };

    window.addEventListener("popstate", handleBackButton);

    return () => {
      window.removeEventListener("popstate", handleBackButton);
    };
  }, []);


  return (
    <>
      <Grid container sx={{ width: "100%", minHeight: "100vh" }}>
        {/* Left Side - Subscription Details */}
        <Grid
          item
          xs={12}
          md={6}
          sx={{
            backgroundColor: "#e0f2f7",
            padding: {
              xs: "30px 20px",
              sm: "40px 30px",
              md: "50px 60px 0px 200px",
            },
          }}
        >
          {!isStripeProcessing && (
            <ArrowBackIcon
              onClick={() => {
                setDiscardOpen(true);
              }}
            />
          )}

          <Container
            sx={{
              justifyContent: "center",
              width: "100%",
            }}
          >
            <SvgIcon
              sx={{
                width: { xs: "50%", md: "25%" },
                height: "auto",
                padding: "15px 0px",
              }}
              component={LoginLogo}
              inheritViewBox
            />

            <Typography
              variant="h6"
              sx={{
                marginBottom: "10px",
                fontWeight: 400,
                color: "text.secondary",
              }}
            >
              Subscribe to{" "}
              {Subcriptiondetails?.package_name ||
                `${isUCAT ? "UCAT" : "GATE"} AI Online Question Bank`}
            </Typography>

            <Box
              sx={{
                display: "flex",
                alignItems: "baseline",
                marginBottom: "20px",
              }}
            >
              <Typography variant="h3" sx={{ fontWeight: "bold" }}>
                A${Subcriptiondetails?.user_cost || Subcriptiondetails?.cost || "9.69"}
              </Typography>
              <Typography sx={{ marginLeft: "5px", fontSize: "15px" }}>
                per {Subcriptiondetails?.billing_period || "week"}
              </Typography>
            </Box>

            <Divider sx={{ marginBottom: "20px" }} />

            {/* Item Details */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "10px",
              }}
            >
              <Box>
                <Typography sx={{ fontWeight: "medium", fontSize: "13px" }}>
                  {Subcriptiondetails?.package_name ||
                    `${isUCAT ? "UCAT" : "GATE"} AI Online Question Bank`}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {isUCAT ? "https://ucat.everesttutoring.com.au/" : "https://learn.everesttutoring.com.au/"}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {getBillingDescription(Subcriptiondetails.user_cost, Subcriptiondetails.billing_type)}
                </Typography>
              </Box>
              <Typography sx={{ fontWeight: "medium", fontSize: "15px" }}>
                A${totalAmount}
              </Typography>
            </Box>

            <Divider sx={{ marginY: "20px" }} />

            {/* Subtotal */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "10px",
              }}
            >
              <Typography sx={{ fontWeight: "medium", fontSize: "13px" }}>
                Subtotal
              </Typography>
              <Typography sx={{ fontWeight: "medium", fontSize: "15px" }}>
                A${totalAmount}
              </Typography>
            </Box>

            <Divider sx={{ marginY: "20px" }} />

            {/* Total Due */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography sx={{ fontWeight: "medium", fontSize: "13px" }}>
                Total due today
              </Typography>
              <Typography sx={{ fontWeight: "bold", fontSize: "18px" }}>
                A${totalAmount}
              </Typography>
            </Box>
          </Container>
        </Grid>

        {/* Right Side - Payment Form */}
        <Grid
          item
          xs={12}
          md={6}
          sx={{
            padding: {
              xs: "30px 20px",
              sm: "40px 30px",
              md: "50px 150px 0px 70px",
            },
          }}
        >
          <StripeWrapper
            paymentCurrency="usd"
            onPaymentSuccess={handlePaymentSuccess}
            onPaymentError={handlePaymentError}
            // onLoadingChange={handleLoadingChange}
            onProcessingChange={setIsStripeProcessing} // 👈 NEW
          />
        </Grid>
      </Grid>
      <React.Fragment>
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle
            id="alert-dialog-title"
            sx={{
              display: "flex",
              justifyItems: "center",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            {isSuccess === true && (
              <img src={Successimage} alt={`sd`} style={{ width: "300px" }} />
            )}
            {isSuccess === false && (
              <ReportGmailerrorredIcon
                sx={{ fontSize: "50px", color: "red" }}
              />
            )}

            <div style={{ fontSize: "20px", color: "#009dff" }}>
              {isSuccess ? "Success" : "Error"}
            </div>
          </DialogTitle>
          <DialogContent>
            <DialogContentText
              id="alert-dialog-description"
              sx={{ fontSize: "15px", textAlign: "center" }}
            >
              {dialogMessage}
            </DialogContentText>
          </DialogContent>
          <DialogActions sx={{ display: "flex", justifyContent: "center" }}>
            <ButtonField
              className="form_save_button"
              onClick={() => {
                dispatch(clearDashboardChart());
                setOpen(false);
                navigate("/dashboard");
                dispatch(clearListSubscription());
              }}
            >
              Ok
            </ButtonField>
          </DialogActions>
        </Dialog>
        <Dialog open={discardOpen} onClose={() => setDiscardOpen(false)}>
          <DialogTitle
            sx={{ textAlign: "center", fontSize: "18px", fontWeight: "600" }}
          >
            Are you sure?
          </DialogTitle>

          <DialogContent>
            <DialogContentText sx={{ textAlign: "center", fontSize: "14px" }}>
              Do you really want to discard subscription process?
            </DialogContentText>
          </DialogContent>

          <DialogActions sx={{ justifyContent: "center" }}>
            <ButtonField
              onClick={() => setDiscardOpen(false)}
              className="form_cancel_button"
            >
              No
            </ButtonField>

            <ButtonField
              onClick={() => {
                setDiscardOpen(false);
                dispatch(clearListSubscription());
                dispatch(clearDashboardChart());
                navigate("/totalexam"); //
              }}
              className="form_save_button"
            >
              Yes, Discard
            </ButtonField>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    </>
  );
};

export default SubscribedPages;
